import { AutogenModelTruckstopPnnTranscoreUsers, AutogenRowTruckstopPnnTranscoreUsers } from "./autogen/AutogenModelTruckstopPnnTranscoreUsers";

export class ModelTruckstopPnnTranscoreUsers extends AutogenModelTruckstopPnnTranscoreUsers<RowTruckstopPnnTranscoreUsers> {
	constructor() {
		super(RowTruckstopPnnTranscoreUsers);
	}
}

export class RowTruckstopPnnTranscoreUsers extends AutogenRowTruckstopPnnTranscoreUsers {
}